import useAsyncData from "../../../../../hooks/use-async-data";
import metaService from "../../../meta.service";
import MetaBillingsTaxiTaxiStatusCounters from "./meta-billings-taxi-taxi-status-counters";

const useMetaBillingsTaxiTaxiStatusCounters = () => {
  const { data, setData, setIsError, setIsLoading, isError, isLoading } =
    useAsyncData<MetaBillingsTaxiTaxiStatusCounters | undefined>(undefined);

  const load = async (signal: AbortSignal) => {
    setIsLoading(true);
    setIsError(false);

    try {
      const metaBillingsTaxiTaxiStatusCounters =
        await metaService.getTaxiTaxiStatusCounters(signal);

      if (!signal.aborted) {
        setData(metaBillingsTaxiTaxiStatusCounters);
      }
    } catch (_error) {
      setIsError(true);
    } finally {
      setIsLoading(false);
    }
  };

  return {
    data,
    isError,
    isLoading,
    load,
  };
};

export default useMetaBillingsTaxiTaxiStatusCounters;
